
import { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useCart }     from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';
import { useUI }       from '../../context/UIContext';
import { useCurrency } from '../../context/CurrencyContext';
import { CURRENCIES }  from '../../lib/currency';
// import { getPublicCategories, getPublicBrands, getSettings } from '../../lib/api';

import { getPublicAllCategories, getPublicBrands, getSettings } from '../../lib/api';

const NAV = [
  ['Shop', '/shop', false],
  ['Categories', null, true],
  ['Brands', null, true],
  ['House', '/about', false],
];

export default function Header() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isHome = pathname === '/';

  const [scrolled,       setScrolled]       = useState(false);
  const [hoveredNav,     setHoveredNav]     = useState(null);
  const [mobileOpen,     setMobileOpen]     = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const [categories,     setCategories]     = useState([]);
  const [brands,         setBrands]         = useState([]);
  const [storeName,      setStoreName]      = useState('ALI Aurora Luxury');
  const [tagline,        setTagline]        = useState('');

  const hideTimer = useRef(null);
  const { totalItems }       = useCart();
  const { ids: wishlistIds } = useWishlist();
  const { openCart, openSearch } = useUI();
  const { idx, cycle }       = useCurrency();

  // useEffect(() => {
  //   getSettings().then(d => {
  //     if (d?.store_name) setStoreName(d.store_name);
  //     if (d?.tagline)    setTagline(d.tagline);
  //   }).catch(() => {});
  //   getPublicCategories().then(d => setCategories(Array.isArray(d) ? d : [])).catch(() => {});
  //   getPublicBrands().then(d => setBrands(Array.isArray(d) ? d : [])).catch(() => {});
  // }, []);

  useEffect(() => {
    getSettings().then(d => {
        if (d?.store_name) setStoreName(d.store_name);
        if (d?.tagline)    setTagline(d.tagline);
    }).catch(() => {});

    // Changed: getPublicCategories → getPublicAllCategories
    getPublicAllCategories()
        .then(d => setCategories(Array.isArray(d) ? d : []))
        .catch(() => {});

    getPublicBrands()
        .then(d => setBrands(Array.isArray(d) ? d : []))
        .catch(() => {});
}, []);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setMobileOpen(false); setMobileExpanded(null); }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const showDD = key => { clearTimeout(hideTimer.current); setHoveredNav(key); };
  const hideDD = ()  => { hideTimer.current = setTimeout(() => setHoveredNav(null), 120); };

  const transparent = isHome && !scrolled && !mobileOpen;
  const textColor   = transparent ? '#fff' : 'var(--dark)';
  const textMuted   = transparent ? 'rgba(255,255,255,0.6)' : 'var(--grey-dark)';

  return (
    <>
      <header style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        background: transparent ? 'transparent' : 'rgba(255,255,255,0.97)',
        backdropFilter: transparent ? 'none' : 'blur(12px)',
        borderBottom: transparent ? 'none' : '1px solid var(--grey)',
        boxShadow: transparent ? 'none' : 'var(--shadow-sm)',
        transition: 'all 0.35s ease',
      }}>
        <div style={{
          maxWidth: 1440, margin: '0 auto', padding: '0 24px',
          height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>

          {/* ── LOGO ── */}
          <Link to="/" style={{ display: 'flex', flexDirection: 'column', gap: 2, lineHeight: 1.2, textDecoration: 'none' }}>
            {tagline && (
              <span style={{ fontSize: 9, letterSpacing: '0.28em', textTransform: 'uppercase', color: textMuted, fontWeight: 500, fontFamily: 'var(--font-body)', transition: 'color 0.35s' }}>
                {tagline}
              </span>
            )}
            <span style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 300, letterSpacing: '0.2em', textTransform: 'uppercase', color: textColor, transition: 'color 0.35s' }}>
              {storeName}
            </span>
          </Link>

          {/* ── DESKTOP NAV ── */}
          <nav className="hide-mobile" style={{ alignItems: 'center', gap: 36, position: 'relative' }}>
            {NAV.map(([label, href, hasDrop]) => (
              <div key={label} onMouseEnter={() => hasDrop && showDD(label)} onMouseLeave={() => hasDrop && hideDD()} style={{ position: 'relative' }}>
                {href
                  ? <Link to={href} style={{ fontSize: 11, letterSpacing: '0.15em', textTransform: 'uppercase', color: pathname === href ? 'var(--gold)' : textColor, textDecoration: 'none', transition: 'color 0.25s' }}>{label}</Link>
                  : <button style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 11, letterSpacing: '0.15em', textTransform: 'uppercase', color: hoveredNav === label ? 'var(--gold)' : textColor, fontFamily: 'var(--font-body)', transition: 'color 0.25s' }}>{label}</button>
                }
                {label === 'Categories' && hoveredNav === 'Categories' && (
                  <div style={DD_STYLE} onMouseEnter={() => showDD('Categories')} onMouseLeave={hideDD}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                      {categories.map(c => <DDItem key={c.id} label={c.name} onClick={() => { navigate(`/shop?category=${encodeURIComponent(c.name)}`); setHoveredNav(null); }} />)}
                    </div>
                    <div onClick={() => { navigate('/categories'); setHoveredNav(null); }} style={VA_STYLE}>All Categories →</div>
                  </div>
                )}
                {label === 'Brands' && hoveredNav === 'Brands' && (
                  <div style={DD_STYLE} onMouseEnter={() => showDD('Brands')} onMouseLeave={hideDD}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                      {brands.map(b => <DDItem key={b.id} label={b.name} onClick={() => { navigate(`/shop?brand=${encodeURIComponent(b.name)}`); setHoveredNav(null); }} />)}
                    </div>
                    <div onClick={() => { navigate('/brands'); setHoveredNav(null); }} style={VA_STYLE}>All Brands →</div>
                  </div>
                )}
              </div>
            ))}
          </nav>

          {/* ── ACTIONS ── */}
          <div style={{ display: 'flex', alignItems: 'center' }}>

            {/* Desktop only actions */}
            <button onClick={cycle} className="hide-mobile"
              style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 500, letterSpacing: '0.05em', color: textMuted, padding: '8px 10px', transition: 'color 0.25s' }}
              onMouseEnter={e => e.target.style.color = 'var(--gold)'}
              onMouseLeave={e => e.target.style.color = textMuted}>
              {CURRENCIES[idx].label}
            </button>

            <IBtn onClick={openSearch} color={textColor} className="hide-mobile">
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
              </svg>
            </IBtn>

            <Link to="/wishlist" className="hide-mobile"
              style={{ position: 'relative', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, color: textColor, transition: 'color 0.25s', textDecoration: 'none' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--gold)'}
              onMouseLeave={e => e.currentTarget.style.color = textColor}>
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
              {wishlistIds.length > 0 && <Dot count={wishlistIds.length} />}
            </Link>

            {/* Desktop cart */}
            <IBtn onClick={openCart} color={textColor} className="hide-mobile">
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 01-8 0"/>
              </svg>
              {totalItems > 0 && <Dot count={totalItems} />}
            </IBtn>

            {/* ── Mobile only: cart + hamburger ── */}
            <IBtn onClick={openCart} color={textColor} className="show-mobile-flex">
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 01-8 0"/>
              </svg>
              {totalItems > 0 && <Dot count={totalItems} />}
            </IBtn>

            {/* Hamburger */}
            <button
              onClick={() => setMobileOpen(o => !o)}
              className="show-mobile-flex"
              aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: textColor, marginLeft: 4,
                alignItems: 'center', justifyContent: 'center', /* ✅ no display here */
                width: 40, height: 40, transition: 'color 0.25s',
              }}
            >
              {mobileOpen
                ? <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                : <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><line x1="3" y1="7" x2="21" y2="7"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="17" x2="21" y2="17"/></svg>
              }
            </button>
          </div>
        </div>
      </header>

      {/* ── MOBILE DRAWER ── */}
      <div style={{
        position: 'fixed', top: 64, left: 0, right: 0, bottom: 0,
        background: '#fff', zIndex: 99,
        transform: mobileOpen ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 0.3s ease',
        overflowY: 'auto',
        display: 'flex', flexDirection: 'column',
      }}>
        <nav style={{ padding: '8px 0', flex: 1 }}>

          <MobileNavLink to="/shop" label="Shop" onClick={() => setMobileOpen(false)} active={pathname === '/shop'} />

          <MobileAccordion
            label="Categories"
            isOpen={mobileExpanded === 'Categories'}
            onToggle={() => setMobileExpanded(p => p === 'Categories' ? null : 'Categories')}
          >
            {categories.map(c => (
              <MobileSubItem key={c.id} label={c.name} onClick={() => { navigate(`/shop?category=${encodeURIComponent(c.name)}`); setMobileOpen(false); }} />
            ))}
            <MobileSubItem label="All Categories →" gold onClick={() => { navigate('/categories'); setMobileOpen(false); }} />
          </MobileAccordion>

          <MobileAccordion
            label="Brands"
            isOpen={mobileExpanded === 'Brands'}
            onToggle={() => setMobileExpanded(p => p === 'Brands' ? null : 'Brands')}
          >
            {brands.map(b => (
              <MobileSubItem key={b.id} label={b.name} onClick={() => { navigate(`/shop?brand=${encodeURIComponent(b.name)}`); setMobileOpen(false); }} />
            ))}
            <MobileSubItem label="All Brands →" gold onClick={() => { navigate('/brands'); setMobileOpen(false); }} />
          </MobileAccordion>

          <MobileNavLink to="/about" label="House" onClick={() => setMobileOpen(false)} active={pathname === '/about'} />

          <div style={{ height: 1, background: 'var(--grey)', margin: '12px 24px' }} />

          <Link to="/wishlist" onClick={() => setMobileOpen(false)}
            style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 24px', textDecoration: 'none', color: 'var(--dark)', fontSize: 13, letterSpacing: '0.05em' }}>
            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
            Wishlist {wishlistIds.length > 0 && (
              <span style={{ background: 'var(--gold)', color: '#fff', fontSize: 9, fontWeight: 700, borderRadius: '50%', width: 16, height: 16, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                {wishlistIds.length}
              </span>
            )}
          </Link>

          <button onClick={() => { openSearch(); setMobileOpen(false); }}
            style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 24px', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--dark)', fontSize: 13, letterSpacing: '0.05em', width: '100%' }}>
            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
            </svg>
            Search
          </button>

          <button onClick={cycle}
            style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 24px', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--dark)', fontSize: 13, letterSpacing: '0.05em', width: '100%' }}>
            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/>
            </svg>
            Currency: {CURRENCIES[idx].label}
          </button>
        </nav>
      </div>
    </>
  );
}

/* ── Mobile sub-components ── */
function MobileNavLink({ to, label, onClick, active }) {
  return (
    <Link to={to} onClick={onClick} style={{ display: 'block', padding: '14px 24px', fontSize: 13, letterSpacing: '0.12em', textTransform: 'uppercase', color: active ? 'var(--gold)' : 'var(--dark)', textDecoration: 'none', borderBottom: '1px solid var(--grey)', fontWeight: active ? 500 : 400 }}>
      {label}
    </Link>
  );
}

function MobileAccordion({ label, isOpen, onToggle, children }) {
  return (
    <div style={{ borderBottom: '1px solid var(--grey)' }}>
      <button onClick={onToggle} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '14px 24px', background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, letterSpacing: '0.12em', textTransform: 'uppercase', color: isOpen ? 'var(--gold)' : 'var(--dark)', fontFamily: 'var(--font-body)' }}>
        {label}
        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"
          style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.25s' }}>
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>
      {isOpen && (
        <div style={{ background: 'var(--grey-light, #fafafa)', paddingBottom: 4 }}>
          {children}
        </div>
      )}
    </div>
  );
}

function MobileSubItem({ label, onClick, gold }) {
  return (
    <div onClick={onClick} style={{ padding: '11px 36px', fontSize: 12, letterSpacing: '0.08em', textTransform: 'uppercase', cursor: 'pointer', color: gold ? 'var(--gold)' : 'var(--dark)', fontWeight: gold ? 600 : 400 }}>
      {label}
    </div>
  );
}

/* ── Desktop sub-components ── */
const DD_STYLE = {
  position: 'absolute', top: 'calc(100% + 20px)', left: '50%',
  transform: 'translateX(-50%)', background: '#fff',
  border: '1px solid var(--grey)', minWidth: 320,
  zIndex: 200, boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
};
const VA_STYLE = {
  padding: '12px 24px', fontSize: 10, textTransform: 'uppercase',
  color: 'var(--gold)', cursor: 'pointer', letterSpacing: '0.1em', fontWeight: 600,
};

function DDItem({ label, onClick }) {
  return (
    <div onClick={onClick}
      style={{ padding: '10px 24px', fontSize: 11, textTransform: 'uppercase', cursor: 'pointer', borderBottom: '1px solid var(--grey)', transition: 'color 0.2s' }}
      onMouseEnter={e => e.currentTarget.style.color = 'var(--gold)'}
      onMouseLeave={e => e.currentTarget.style.color = 'var(--dark)'}>
      {label}
    </div>
  );
}

/* ── IBtn — NO display in inline style, controlled by className ── */
function IBtn({ onClick, color, children, className }) {
  return (
    <button
      onClick={onClick}
      className={className}
      style={{
        background: 'none', border: 'none', cursor: 'pointer',
        color, marginLeft: 4,
        alignItems: 'center', justifyContent: 'center', /* ✅ no display property */
        width: 40, height: 40,
        transition: 'color 0.25s', position: 'relative',
      }}
      onMouseEnter={e => e.currentTarget.style.color = 'var(--gold)'}
      onMouseLeave={e => e.currentTarget.style.color = color}>
      {children}
    </button>
  );
}

function Dot({ count }) {
  return (
    <span style={{ position: 'absolute', top: 4, right: 4, width: 16, height: 16, borderRadius: '50%', background: 'var(--gold)', color: '#fff', fontSize: 9, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {count}
    </span>
  );
}